<template>
  <el-dialog :visible.sync="visible" title="签名二维码" width="300px" center>
    <div class="flex row-center">
      <qrcode-vue :value="qrUrl" :size="200" />
    </div>
  </el-dialog>
</template>

<script>
import qrcodeVue from 'qrcode.vue'
import Cookies from 'js-cookie'
import { purchaseTypeDict } from '@/dictionary/project/common'
/**
 * 签名二维码弹窗
 */
export default {
  name: 'OnlineReviewSignQrDialog',

  components: { qrcodeVue },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    }
  },

  data() {
    return {
      visible: false,
      qrUrl: ''
    }
  },

  mounted() {
    const returnUrl = encodeURIComponent(
      JSON.stringify({
        name: 'ReviewMobileValidate',
        params: { reviewId: this.reviewId, orderId: this.orderId },
        query: { purchaseType: this.purchaseType }
      })
    )
    this.qrUrl =
      process.env.VUE_APP_EXPERT_H5_URL + `/blank-page?&returnUrl=${returnUrl}`
  }
}
</script>

<style scoped lang="scss"></style>
